// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search_div_left {\r\n  width: 70%;\r\n  float: left;\n}\n.search_div_right {\r\n  width: 30%;\r\n  float: left;\r\n  text-align: right;\n}\r\n", ""]);
// Exports
module.exports = exports;
